import { Component } from "react";
import { Flex, Button } from "@chakra-ui/react";
import { H4, Subtitle, Subtitle2 } from "src/atoms/typography";
import IconOnBackground from "src/components/IconOnBackground";
import RecorderStatus from "../../RecorderStatusEnum";
import { ReactComponent as MicrophoneIcon } from "./icons/microphone.svg";
import { ReactComponent as StopIcon } from "src/modules/command/icons/stop.svg";
import { ReactComponent as PlayIcon } from "src/modules/command/icons/play.svg";
import time from "src/utils/time";

const UPDATE_INTERVAL_PERIOD = 800;

export default class AudioRecorder extends Component {
  updateSelfIntervalId = null;

  componentDidUpdate(prevProps, prevState) {
    const { status } = this.props;
    if (status !== RecorderStatus.RECORDING) {
      this.updateSelfIntervalId && clearInterval(this.updateSelfIntervalId);
      this.updateSelfIntervalId = null;
      return;
    }
    if (this.updateSelfIntervalId === null) {
      this.updateSelfIntervalId = setInterval(
        () => this.forceUpdate(),
        UPDATE_INTERVAL_PERIOD
      );
    }
  }
  componentWillUnmount() {
    this.updateSelfIntervalId && clearInterval(this.updateSelfIntervalId);
  }

  render() {
    const {
      t,
      status,
      togglePlay,
      toggleRecord,
      recordingDuration,
      replayCurrentTime,
      recordingStartDate
    } = this.props;
    const recordingCurrentTime = time().diff(recordingStartDate);

    const mapStatusToContent = {
      [RecorderStatus.PAUSED_NO_RECORDING]: (
        <>
          <IconOnBackground
            icon={MicrophoneIcon}
            fill="white"
            bg="#ff4f41"
            iconSize="28px"
            size="56px"
            onClick={toggleRecord}
          />
          <H4 color="highEmphasis" mt="16px">
            {t("command.editor.recorder.noVoiceRecorded")}
          </H4>
          <Subtitle color="mediumEmphasis">{t("clickToRecord")}</Subtitle>
        </>
      ),
      [RecorderStatus.RECORDING]: (
        <>
          <IconOnBackground
            icon={StopIcon}
            fill="#ff4f41"
            bg="white"
            iconSize="28px"
            size="56px"
            onClick={toggleRecord}
          />
          <H4 mt="16px" color="white">
            {t("recording")}
          </H4>
          <Subtitle2 color="white70">
            {time
              .duration(recordingCurrentTime)
              .format("mm:ss", { stopTrim: "m" })}
          </Subtitle2>
        </>
      ),
      [RecorderStatus.PAUSED_HAS_RECORDING]: (
        <>
          <IconOnBackground
            icon={PlayIcon}
            bg="#ff4f41"
            fill="white"
            iconSize="28px"
            size="56px"
            onClick={togglePlay}
          />
          <H4 mt="16px" color="highEmphasis">
            {t("command.editor.recorder.voiceRecorded")}
          </H4>
          <Subtitle2 color="mediumEmphasis">
            {time
              .duration(recordingDuration)
              .format("mm:ss", { stopTrim: "m" })}
          </Subtitle2>
          <Button
            variant="flatPrimary"
            position="absolute"
            transform="translateX(-50%)"
            bottom="16px"
            left="50%"
            onClick={toggleRecord}
          >
            {t("buttons.recordAgain")}
          </Button>
        </>
      ),
      [RecorderStatus.PLAYING]: (
        <>
          <IconOnBackground
            icon={StopIcon}
            bg="#ff4f41"
            fill="white"
            iconSize="28px"
            size="56px"
            onClick={togglePlay}
          />
          <H4 mt="16px" color="highEmphasis">
            {t("command.editor.recorder.playing")}
          </H4>
          <Subtitle2 color="mediumEmphasis">
            {time
              .duration(replayCurrentTime)
              .format("mm:ss", { stopTrim: "m" })}
          </Subtitle2>
          <Button
            variant="flatPrimary"
            position="absolute"
            transform="translateX(-50%)"
            bottom="16px"
            left="50%"
            onClick={toggleRecord}
          >
            {t("buttons.recordAgain")}
          </Button>
        </>
      )
    };

    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        bg={
          status === RecorderStatus.RECORDING ? "#fb594c" : "surfaceElevated1"
        }
        position="relative"
        height="100%"
        borderRadius="13px"
        border="solid 1px"
        borderColor="outline"
      >
        {mapStatusToContent[status] ||
          mapStatusToContent[RecorderStatus.PAUSED_NO_RECORDING]}
      </Flex>
    );
  }
}
